import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import './headerDetails.css'
import { HEADER_DETAILS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function StopChequeHeaderDetails({ option = {} }) {
  const { t } = useTranslation()
  return (
    <div className='approval-card-header '>
      <span>
        <span className='span1'>
          {t(HEADER_DETAILS_KEYS.ACCOUNT_NO)}. : {option?.accNo}
        </span>
        <span className='mt-2 span2'>{option?.reason}</span>
      </span>
      <span>
        <span className='span3'>
          {`${t(HEADER_DETAILS_KEYS.CHEQUE_NO)} :`} {option?.startChequeNo} to {option?.endChequeNo}
        </span>
        <span className='mt-2 span2 text-right'>
          {option?.initDate !== null ? option?.initDate : '-'}
        </span>
      </span>
    </div>
  )
}
